import React from 'react';
// import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal'
import Tick from '../images/tick.gif'

const propTypes = {};

const defaultProps = {};

const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
}

export default class ContactForm extends React.Component {
    state = {
        firstname: "",
        lastname: " ",
        email: " ",
        phone: " ",
        message: " ",
        model: "",
        open: false,
    };


    handleSubmit = e => {
        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({ "form-name": "Contact", ...this.state })
        })
            .then(() => { this.setState({ open: true }); console.log("open") })

            .catch(error => alert(error));
        e.preventDefault();
    };


    changeHandler = (getname, event) => {
        var st = {}
        st[getname] = event.target.value
        this.setState(st)
        console.log("saasd", st)
    };
    onCloseModal = () => {
        this.setState({ open: false });
    };

    render() {
        return (
            <>
                <form id="validation-form" className="h-100" name="Contact" netlify-honeypot="bot-field" data-netlify="true" method="POST" onSubmit={this.handleSubmit}>
                    <p id="hidden">
                        <label>Don’t fill this out if you're human: <input name="bot-field" /></label>
                    </p>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control" name="firstname" placeholder="Firstname" value={this.state.firstname} onChange={(e) => this.changeHandler('firstname', e)} required />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control" name="lastname" placeholder="Lastname" value={this.state.lastname} onChange={(e) => this.changeHandler('lastname', e)} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <input type="email" className="form-control" name="email" placeholder="Email" value={this.state.email} onChange={(e) => this.changeHandler('email', e)} required />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <input type="number" className="form-control" name="phone" placeholder="Phone" value={this.state.phone} onChange={(e) => this.changeHandler('phone', e)} required />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <textarea className="form-control message" name="message" placeholder=" Message" value={this.state.message} onChange={(e) => this.changeHandler('message', e)} >
                                </textarea>
                            </div>
                        </div>
                        <div className="w-100 text-left">
                            <input type="submit" className="btn btn-primary btn-rounded" value="Contact Now" />
                        </div>
                    </div>
                </form>
                {typeof window !== `undefined` ?
                    <Modal classNames={{ modal: "Submit_Form" }} open={this.state.open} onClose={this.onCloseModal} center>
                        <h1 className="text-white text-center text-uppercase font-weight-bold">Thank you!</h1>
                        <img className="mx-auto d-block" src={Tick} alt="tick" />
                        <h4 className="text-white text-center">Thank you for contacting us.</h4>
                        <p className="text-center text-white">One of our representatives will be in contact with you shortly regarding your inquiry.<br /> If you ever have any questions that require immediate assistance.<br />please call us at <a href="tel:+919910580555">+91-9910580555.</a></p>
                    </Modal> : null}
            </>
        );
    }
}

ContactForm.propTypes = propTypes;
ContactForm.defaultProps = defaultProps;